export default function SumoRingIcon() {
  return (
    <svg viewBox="0 0 64 64" aria-hidden="true">
      <path d="M6 46h52l5 14H1z" fill="#B97A45" stroke="#24130A" strokeWidth="2" strokeLinejoin="round" />
      <path d="M8 42h48l2 4H6z" fill="#E2BD86" stroke="#24130A" strokeWidth="2" strokeLinejoin="round" />
      <circle cx="22" cy="31" r="11" fill="#F6C8A0" stroke="#24130A" strokeWidth="2" />
      <path d="M12.5 35h19a11 11 0 0 1-19 0z" fill="#2F6FE0" />
      <circle cx="22" cy="16" r="6" fill="#F6C8A0" stroke="#24130A" strokeWidth="2" />
      <circle cx="20" cy="9.5" r="2.6" fill="#2A1A12" />
      <circle cx="44" cy="29" r="11" fill="#9A6A43" stroke="#24130A" strokeWidth="2" transform="rotate(14 44 29)" />
      <path d="M35 34h18a11 11 0 0 1-18 0z" fill="#FF4F7B" transform="rotate(14 44 29)" />
      <circle cx="48" cy="14" r="6" fill="#9A6A43" stroke="#24130A" strokeWidth="2" />
      <path d="M31 26l8 1" stroke="#F6C8A0" strokeWidth="5" strokeLinecap="round" />
      <path d="M36 21l3-4M39 24l4-2M37 28l4 1" stroke="#FFD23F" strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
}
